'use client'

import PropsProvider from '@mui/material/DefaultPropsProvider'
import NextLink, { LinkProps as NextLinkProps } from 'next/link'
import { usePathname } from 'next/navigation'
import { forwardRef, useEffect } from 'react'
import { useAnalytics } from '~/app/_hooks/use_analytics'

export default function Config({
  children,
}: Readonly<{
  children: React.ReactNode
}>) {
  const analytics = useAnalytics()
  const pathname = usePathname()

  useEffect(() => {
    analytics.init()
    return () => analytics.destroy()
  }, [])

  useEffect(() => {
    analytics.page({ pathname })
  }, [pathname])

  return (
    <PropsProvider
      value={{
        MuiLink: {
          component: Link,
        },
        MuiButtonBase: {
          LinkComponent: Link,
        },
      }}
    >
      {children}
    </PropsProvider>
  )
}

const Link = forwardRef<HTMLAnchorElement, NextLinkProps>(
  function LinkBehaviour(props, ref) {
    if (!props.href) {
      return (
        <a ref={ref} {...props} href={props.href} style={{ cursor: 'pointer' }} />
      )
    }
    return <NextLink ref={ref} prefetch={false} {...props} />
  },
)
